module.exports = __webpack_public_path__ + "img/ringsets.99544d1.jpg";